import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { formatDateTime } from '../../../utils/date-utils';
import PmuLogo from '../../../../assets/img/logo-pmu.png';

import HeaderSearch from './search/HeaderSearch.jsx';
import HeaderUser from './HeaderUser.jsx';

import * as documentActions from '../../../../documents/documentsDucks';
import * as newsActions from '../../../../news/newsDucks';

const Header = ({ loadDocuments, loadNews, lastUpdated }) => (
  <div className="header" id="header">
    <div className="logo">
      <Link to="/" onClick={() => { loadDocuments(); loadNews(); }}>
        <img src={PmuLogo} alt="PMU"/>
      </Link>
      <div>
        <h2>Le BOOK de visite</h2>
        <p>{lastUpdated ? `Synchronisé le ${formatDateTime(lastUpdated)}` : 'Synchronisation en cours'}</p>
      </div>
    </div>

    <HeaderSearch/>
    <HeaderUser/>
  </div>
);


const selector = state => ({
  lastUpdated: state.documents.lastUpdated,
});

export default connect(selector, {
  ...documentActions,
  ...newsActions,
})(Header);



// WEBPACK FOOTER //
// ./book/src/commons/components/layout/header/Header.jsx